export default 'promoted-content'
